import dynamic from "next/dynamic";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useRouter } from "next/router";
import { CardAdd } from "iconsax-react";
import Button from "@mui/material/Button";
import { Fragment, useState } from "react";

import Pages from "src/constants/pages";
import Wrapper from "src/components/layout/wrapper";
const Facility = dynamic(() => import("./Facility"));
import { CREDIT_LAYER_ENUM } from "src/types/facility";
const Loading = dynamic(() => import("./Facility/Loading"));
import { useGetAllUserFacility } from "src/services/new-facility";
const FacilityHistory = dynamic(() => import("./FacilityHistory"));
const EmptyFacility = dynamic(() => import("./Facility/EmptyFacility"));
const ShowAirConditionerProducts = dynamic(() => import("../requests/components/facility-info/ShowAirConditionerProducts"));

export default function Content() {
    const { push, query } = useRouter();
    const [value, setValue] = useState(0);
    const layerId = query?.creditLayerId || "";
    const { data, isLoading } = useGetAllUserFacility();

    const handleChange = (event: React.SyntheticEvent, newValue: number) => setValue(newValue);

    return (
        <Wrapper title="تسهیلات" toolbarHref={Pages.Main} showToolbar>
            {isLoading ? <Loading /> : data?.value && data?.value?.length > 0 ?
                <Fragment>
                    <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", flexDirection: { xs: "column", md: "row" }, justifyContent: "space-between" }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="icon position tabs example"
                        >
                            <Tab iconPosition="start" label="تسهیلات فعال" />
                            <Tab iconPosition="start" label="تاریخچه تسهیلات" />
                        </Tabs>
                        <Button
                            size="small"
                            variant="contained"
                            startIcon={<CardAdd />}
                            sx={{ height: 35, mt: { xs: 2, md: 1 }, width: { xs: "fit-content", md: "auto" } }}
                            onClick={() => push(`${Pages.SelectFacility}?creditLayerId=${layerId}`)}
                        >
                            درخواست جدید
                        </Button>
                    </Box>
                    <CustomTabPanel value={value} index={0}>
                        <Facility data={data?.value} />
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <FacilityHistory />
                    </CustomTabPanel>
                </Fragment>
                :
                <EmptyFacility />
            }
            {+layerId === CREDIT_LAYER_ENUM.AIR_CONDITIONER && <ShowAirConditionerProducts />}
        </Wrapper>
    );
};

interface TabPanelProps {
    index: number;
    value: number;
    children?: React.ReactNode;
};

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
        </div>
    );
};